/**
 * @generated SignedSource<<31e50825e3fe8cb62e6439b7fdd19494>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ValidateWeekendVisibilityChangeInput = {
  weekendDisplayPerUser?: boolean | null;
  weekendDisplayShowAlways?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ValidateWeekendVisibilityChangeMutation$variables = {
  input: ValidateWeekendVisibilityChangeInput;
};
export type ValidateWeekendVisibilityChangeMutation$data = {
  readonly validateWeekendVisibilityChange: {
    readonly isCompanyPrevented: boolean | null;
    readonly isActiveUserPrevented: boolean | null;
    readonly isInactiveUserPrevented: boolean | null;
  } | null;
};
export type ValidateWeekendVisibilityChangeMutation = {
  variables: ValidateWeekendVisibilityChangeMutation$variables;
  response: ValidateWeekendVisibilityChangeMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateWeekendVisibilityChangePayload",
    "kind": "LinkedField",
    "name": "validateWeekendVisibilityChange",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCompanyPrevented",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActiveUserPrevented",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isInactiveUserPrevented",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateWeekendVisibilityChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateWeekendVisibilityChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "05d3724ce668d6d69818b4ff7ef49a74",
    "id": null,
    "metadata": {},
    "name": "ValidateWeekendVisibilityChangeMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateWeekendVisibilityChangeMutation(\n  $input: ValidateWeekendVisibilityChangeInput!\n) {\n  validateWeekendVisibilityChange(input: $input) {\n    isCompanyPrevented\n    isActiveUserPrevented\n    isInactiveUserPrevented\n  }\n}\n"
  }
};
})();

(node as any).hash = "2c9057dacf2b9b4dfe7a44060ac552c4";

export default node;
